// let brandMenuHTML = '';
// let brandMenuInjected = false;
// let isLoading = false;
// const BRANDS_CACHE_KEY = 'brands_menu_html_cache_v1';
// function extractBrandsHTML(html) {
// const doc = new DOMParser().parseFromString(html, 'text/html');
// const section = doc.querySelector('.brands_section');
// return section && section.innerHTML.trim() ? section.innerHTML : '';
// }
// function fetchBrandsPage() {
// return fetch('/pages/brand-menu', { credentials: 'same-origin' })
//     .then(res => {
//     if (!res.ok) throw new Error('Request failed');
//     return res.text();
//     });
// }
// function loadBrandMenuHTML() {
// return fetchBrandsPage()
//     .then(html => {
//     const parsed = extractBrandsHTML(html);
//     if (!parsed) throw new Error('No brands section');
//     return parsed;
//     });
// }

// function initBrandData() {

// if (brandMenuInjected || isLoading) return;

// const $container = $('#brand-menu-ajax');
// $container
// .addClass('loading-in-progress')
// .html('<span class="loader"></span>');
// try {
// const cached = sessionStorage.getItem(BRANDS_CACHE_KEY);
// if (cached && cached.trim()) {
//     brandMenuHTML = cached;

//     $container
//     .removeClass('loading-in-progress') // ✅ ADD THIS
//     .html(brandMenuHTML);

//     initBrands();
//     brandMenuInjected = true;
//     return;
// }
// } catch (e) {}

// isLoading = true;

// loadBrandMenuHTML()
// .then(menuHTML => {
//     brandMenuHTML = menuHTML;

//     try {
//     sessionStorage.setItem(BRANDS_CACHE_KEY, menuHTML);
//     } catch (e) {}

//     $container
//     .removeClass('loading-in-progress')
//     .html(brandMenuHTML);
//     initBrands();
//     brandMenuInjected = true;
// })
// .catch(() => {
//     $container
//     .removeClass('loading-in-progress')
//     .html('<p>Failed to load brands</p>');
// })
// .finally(() => {
//     isLoading = false;
// });
// }

// $(document).ready(function () {
// initBrandData();
// });

// $(document).on('click', '.mobile-drawer-hamburger-menu', function () {
// $('body').addClass('overflow-hidden');
// $('.mask-overlay').addClass('mask_opened');
// $('#mobile-tab-menu').addClass('active');
// });

// $(document).on('click', '.mobile-drawer-close-icon, .mask-overlay', function () {
// $('body').removeClass('overflow-hidden');
// $('#mobile-tab-menu').removeClass('active');
// $('.mask-overlay').removeClass('mask_opened');
// });

// $(document).on('click', '.mobile-tab-btn', function (e) {
// e.preventDefault();

// const tabKey = $(this).data('tab-label');

// $('.mobile-tab-btn').removeClass('active');
// $(this).addClass('active');

// $('.mobile-tab-content').removeClass('active').hide();
// $('[data-tab-content="' + tabKey + '"]').addClass('active').fadeIn(200);
// });

// $(document).on('click', '.menu-parent-label', function (e) {
// // e.preventDefault();
// // e.stopPropagation();

// const parent = $(this).closest('.mega-menu-label__item');
// const content = parent.children('.mega-menu__children');

// if (!content.length) return;

// parent.toggleClass('active');
// content.stop(true, true).slideToggle(250);
// });

// $(document).on('click', '.mega-menu__child-heading-nav', function (e) {
// e.preventDefault();
// e.stopPropagation();

// const parent = $(this).closest('.mega-menu__child');
// const submenu = parent.children('.mega-menu__sub-list-inner');

// if (!submenu.length) return;

// parent.toggleClass('active_inner');
// submenu.stop(true, true).slideToggle(200);
// });

// $(document).on('click', '.nav_link_icon', function (e) {
// e.preventDefault();
// e.stopPropagation();

// const childNav = $(this).closest('.mega-menu__child').children('.mega-menu__child-heading-nav');
// const parentLabel = $(this).closest('.mega-menu-label__item').children('.menu-parent-label');

// if (childNav.length) {
//     childNav.trigger('click');
//     return;
// }

// if (parentLabel.length) {
//     parentLabel.trigger('click');
// }
// });

// function initBrands() {

// const $list = $('#menu_mb_ul li');
// const $btn = $('#show-more-btn');
// const $search = $('.brand-search-box');

// if (!$list.length) return;

// let step = 10;
// let visibleCount = step;

// $list.hide().slice(0, step).show();

// $btn.off('click').on('click', function () {
//     visibleCount += step;
//     $list.slice(0, visibleCount).fadeIn(150);

//     if (visibleCount >= $list.length) {
//     $btn.hide();
//     }
// });

// let debounce;

// $search.off('input').on('input', function () {

//     clearTimeout(debounce);

//     debounce = setTimeout(() => {

//     const query = $(this).val().toLowerCase();
//     let found = false;

//     $list.each(function () {
//         const text = $(this).text().toLowerCase();
//         const match = text.includes(query);

//         $(this).toggle(match);
//         if (match) found = true;
//     });

//     $('#search-results').html(
//         found ? '' : '<div style="text-align:center;padding:10px;">Brand not found</div>'
//     );

//     if (!query) {
//         $list.hide().slice(0, visibleCount).show();
//         $btn.toggle(visibleCount < $list.length);
//     } else {
//         $btn.hide();
//     }

//     }, 200);

// });
// }


let brandMenuHTML = '';
let brandMenuInjected = false;
let isLoading = false;
let retryCount = 0;
const MAX_RETRIES = 3;
const RETRY_DELAY = 1500;
const BRANDS_CACHE_KEY = 'brands_menu_html_cache_v1';
const BRANDS_CACHE_TS_KEY = 'brands_menu_html_cache_ts_v1';
const CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes

function extractBrandsHTML(html) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var section = doc.querySelector('.brands_section');
  return section && section.innerHTML.trim() ? section.innerHTML : '';
}

function fetchBrandsPage() {
  return fetch('/pages/brand-menu', {
    credentials: 'same-origin',
    cache: 'no-store'
  }).then(function(res) {
    if (!res.ok) throw new Error('Request failed: ' + res.status);
    return res.text();
  });
}

function loadBrandMenuHTML() {
  return fetchBrandsPage().then(function(html) {
    var parsed = extractBrandsHTML(html);
    if (!parsed) throw new Error('No brands section found');
    return parsed;
  });
}

function isCacheValid() {
  try {
    var ts = sessionStorage.getItem(BRANDS_CACHE_TS_KEY);
    if (!ts) return false;
    return (Date.now() - parseInt(ts, 10)) < CACHE_TTL_MS;
  } catch (e) {
    return false;
  }
}

function getCachedHTML() {
  try {
    if (!isCacheValid()) return null;
    var cached = sessionStorage.getItem(BRANDS_CACHE_KEY);
    return (cached && cached.trim()) ? cached : null;
  } catch (e) {
    return null;
  }
}

function setCachedHTML(html) {
  try {
    sessionStorage.setItem(BRANDS_CACHE_KEY, html);
    sessionStorage.setItem(BRANDS_CACHE_TS_KEY, String(Date.now()));
  } catch (e) {}
}

function clearCache() {
  try {
    sessionStorage.removeItem(BRANDS_CACHE_KEY);
    sessionStorage.removeItem(BRANDS_CACHE_TS_KEY);
  } catch (e) {}
}

function injectBrandMenu(html) {
  var $container = $('#brand-menu-ajax');
  $container.removeClass('loading-in-progress').html(html);
  initBrands();
  brandMenuInjected = true;
  brandMenuHTML = html;
}

function attemptFetch(attempt) {
  loadBrandMenuHTML()
    .then(function(menuHTML) {
      setCachedHTML(menuHTML);
      injectBrandMenu(menuHTML);
    })
    .catch(function(err) {
      if (attempt < MAX_RETRIES) {
        setTimeout(function() {
          attemptFetch(attempt + 1);
        }, RETRY_DELAY * attempt);
      } else {
        // All retries failed — clear stale cache, hide container gracefully
        clearCache();
        $('#brand-menu-ajax')
          .removeClass('loading-in-progress')
          .html(''); // Silently empty — do NOT show "Failed to load brands"
      }
    })
    .finally
      ? loadBrandMenuHTML().then(function(){}).catch(function(){}) // no-op, handled above
      : undefined;

  // Manually track loading state since .finally may not be polyfilled
  // We reset isLoading after the promise chain settles via a flag approach
}

function initBrandData() {
  if (brandMenuInjected || isLoading) return;

  // Try cache first
  var cached = getCachedHTML();
  if (cached) {
    injectBrandMenu(cached);
    return;
  }

  isLoading = true;

  var $container = $('#brand-menu-ajax');
  $container
    .addClass('loading-in-progress')
    .html('<span class="loader"></span>');

  loadBrandMenuHTML()
    .then(function(menuHTML) {
      setCachedHTML(menuHTML);
      injectBrandMenu(menuHTML);
      isLoading = false;
    })
    .catch(function() {
      if (retryCount < MAX_RETRIES) {
        retryCount++;
        isLoading = false;
        setTimeout(initBrandData, RETRY_DELAY * retryCount);
      } else {
        // Graceful silent failure — empty container, don't block UX
        clearCache();
        $container
          .removeClass('loading-in-progress')
          .html('');
        isLoading = false;
      }
    });
}

$(document).ready(function () {
  // Defer brand menu init slightly so it doesn't block critical page render
  setTimeout(initBrandData, 200);
});

$(document).on('click', '.mobile-drawer-hamburger-menu', function () {
  $('body').addClass('overflow-hidden');
  $('.mask-overlay').addClass('mask_opened');
  $('#mobile-tab-menu').addClass('active');

  // Retry loading if it failed before and menu was opened
  if (!brandMenuInjected && !isLoading) {
    retryCount = 0;
    initBrandData();
  }
});

$(document).on('click', '.mobile-drawer-close-icon, .mask-overlay', function () {
  $('body').removeClass('overflow-hidden');
  $('#mobile-tab-menu').removeClass('active');
  $('.mask-overlay').removeClass('mask_opened');
});

$(document).on('click', '.mobile-tab-btn', function (e) {
  e.preventDefault();

  var tabKey = $(this).data('tab-label');

  $('.mobile-tab-btn').removeClass('active');
  $(this).addClass('active');

  $('.mobile-tab-content').removeClass('active').hide();
  $('[data-tab-content="' + tabKey + '"]').addClass('active').fadeIn(200);
});

$(document).on('click', '.menu-parent-label', function (e) {
  var parent = $(this).closest('.mega-menu-label__item');
  var content = parent.children('.mega-menu__children');

  if (!content.length) return;

  parent.toggleClass('active');
  content.stop(true, true).slideToggle(250);
});

$(document).on('click', '.mega-menu__child-heading-nav', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var parent = $(this).closest('.mega-menu__child');
  var submenu = parent.children('.mega-menu__sub-list-inner');

  if (!submenu.length) return;

  parent.toggleClass('active_inner');
  submenu.stop(true, true).slideToggle(200);
});

$(document).on('click', '.nav_link_icon', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var childNav = $(this).closest('.mega-menu__child').children('.mega-menu__child-heading-nav');
  var parentLabel = $(this).closest('.mega-menu-label__item').children('.menu-parent-label');

  if (childNav.length) {
    childNav.trigger('click');
    return;
  }

  if (parentLabel.length) {
    parentLabel.trigger('click');
  }
});

function initBrands() {
  var $list = $('#menu_mb_ul li');
  var $btn = $('#show-more-btn');
  var $search = $('.brand-search-box');

  if (!$list.length) return;

  var step = 10;
  var visibleCount = step;

  $list.hide().slice(0, step).show();

  $btn.off('click').on('click', function () {
    visibleCount += step;
    $list.slice(0, visibleCount).fadeIn(150);

    if (visibleCount >= $list.length) {
      $btn.hide();
    }
  });

  var debounce;

  $search.off('input').on('input', function () {
    clearTimeout(debounce);

    debounce = setTimeout(function() {
      var query = $search.val().toLowerCase();
      var found = false;

      $list.each(function () {
        var text = $(this).text().toLowerCase();
        var match = text.includes(query);
        $(this).toggle(match);
        if (match) found = true;
      });

      $('#search-results').html(
        found ? '' : '<div style="text-align:center;padding:10px;">Brand not found</div>'
      );

      if (!query) {
        $list.hide().slice(0, visibleCount).show();
        $btn.toggle(visibleCount < $list.length);
      } else {
        $btn.hide();
      }
    }, 200);
  });
}
